/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2023, Zumper
 */

import type { DetailPageContextType } from '@zcode-ui/web-zumper-pages'
import { AnalyticsC } from '@zcode/nr-utils'
import React, { type ForwardedRef, forwardRef } from 'react'
import type { GetProps } from 'react-redux'
import { MessageButtonContainer } from '../../components/MessageButton/MessageButtonContainer'

export const DetailMessageButton = forwardRef(
  (
    props: GetProps<DetailPageContextType['MessageButton']>,
    ref: ForwardedRef<HTMLAnchorElement & HTMLButtonElement>
  ) => {
    const { entity, text, selectedFloorplan, ...rest } = props
    if (!entity) {
      return null
    }
    const isWaitlistEnabled = selectedFloorplan
      ? selectedFloorplan.waitlistEnabled
      : entity.waitlistEnabled
    if (!entity.isActive && !isWaitlistEnabled) {
      return null
    }
    return (
      <MessageButtonContainer
        analyticChannel={AnalyticsC.FULL_DETAIL}
        disableOneTap={entity.isSpecialtyHousing}
        entity={entity}
        equalCTAIntent={isWaitlistEnabled ? 'Waitlist' : undefined}
        ref={ref}
        selectedFloorplan={selectedFloorplan}
        showMessagedState={false}
        text={text ?? (isWaitlistEnabled ? 'Ask to join waitlist' : 'Check availability')}
        variant="pink"
        {...rest}
      />
    )
  }
)
